import axios from 'axios';
import { BoundTls } from './BoundTls';
import { MapTls } from './MapTls';
import { UrlTls } from './UrlTls';
import { Drawer } from '../drawer/Drawer';

const ApiTls = {
    getFreeData(tableName,whereName,whereValue,myFunction){
        axios.get(UrlTls.getBaseUrl()+'/free/' + tableName+
        '/'+whereName+'/'+whereValue)
        .then(function (res) {
            myFunction(res);
        })
        .catch(function (e) { console.log(e); });
    },
    getFeederData(feederId, myFunction) {
        // myFunction pass res
        axios.get(UrlTls.getBaseUrl()+'/feeder/' + feederId)
            .then(function (res) {
                // [polesArr,linesArr]=res.data;
                // console.log(res.data);
                myFunction(res);

            })
            .catch(function (e) { console.log(e); });
        // .catch(e=>console.log(e))
    },
    getBoundData(min, max, myFunction) {
        // min:{x:2233,y:dd}
        // myFunction pass res
        axios.get(UrlTls.getBaseUrl()+'/minmax?min_x=' + min.x + '&min_y=' + min.y + '&max_x=' + max.x + '&max_y=' + max.y)
            .then(function (res) {
                // [polesArr,linesArr]=res.data;
                // console.log(res.data);
                myFunction(res);

            })
            .catch(function (e) { console.log(e); });
        // .catch(e=>console.log(e))
    },
    getAllCurrentViewData(mymap) {
        var sw = mymap.getBounds()._southWest.utm();
        var ne = mymap.getBounds()._northEast.utm();

        this.getBoundData({ x: sw.x, y: sw.y }, { x: ne.x, y: ne.y }, function (res) {
            // mymap.eachLayer(function (layer) {
            //     mymap.removeLayer(layer);
            // });
            mymap.clearLayers();
            BoundTls.resetMinMaxBound();

            Drawer.drawAll(mymap, res.data);
            // MapTls.fitTo(mymap);
            MapTls.typeBounds(document, mymap);

            
        });

    },
    
    drawTransAndMVPoles(mymap) {
        var sw = mymap.getBounds()._southWest.utm();
        var ne = mymap.getBounds()._northEast.utm();

        this.getBoundData({ x: sw.x, y: sw.y }, { x: ne.x, y: ne.y }, function (res) {
            
            Drawer.drawAllMvPoles(mymap, res.data);
            Drawer.drawAllTrans(mymap, res.data);
            // MapTls.fitTo(mymap);
            MapTls.typeBounds(document, mymap);
        });

    },
    startTmp(mymap, feederId) {
        ApiTls.getFeederData(feederId, function (res) {
            Drawer.drawAll(mymap, res.data);
            MapTls.fitTo(mymap);
            MapTls.typeBounds(document, mymap);
        });

        // this.getBoundData({ x: 299700, y: 3797910 }, { x: 299900, y: 3798030 }, function (res) {

        //     Drawer.drawAll(mymap, res.data);
        //     MapTls.fitTo(mymap);
        //     MapTls.typeBounds(document, mymap);
        // });
    },
    postNewFeederIds(){

    }

}





export { ApiTls }